import presentation from "../../content/registry/presentation.json";

export type MediaStat = {
  label: string;
  value: string;
  note: string;
  url?: string;
  linkLabel?: string;
};

export type MediaSnippet = {
  title: string;
  summary: string;
};

export const mediaSnapshot = presentation.mediaSnapshot;
export const mediaStats: MediaStat[] = presentation.mediaStats;
export const mediaSnippets: MediaSnippet[] = presentation.mediaSnippets;
